<template>
  <div class="main">
    <div class="background">
      <div class="loginBox">
        <div class="loginImg"><img src="../assets/login/login_img.png"></div>
          <div class="loginContent">
            <div>
              <div class="title"><img src="../assets/login//title.png"></div>
              <div class="Input mail">
                <input name="" type="text" placeholder="Email" v-on:keyup.enter="login" v-model="auth.account"  required>
                  <p v-if="auth.account==='' && check === true">Please enter your email</p>
              </div>
              <div class="Input pw">
                <input name="" placeholder="Password" v-on:keyup.enter="login" v-model="auth.password" type="password" required>
                  <p v-if="auth.password==='' && check === true">Please enter your password</p>
              </div>
              <button @click="login">login</button>
            <div class="logo"><img src="../assets/login/liveABC_logo.png"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
// import api from '../store/api'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      // toggle: false,
      auth: {
        account: '',
        password: ''
      },
      check: false,
      groupList: {}
    }
  },
  props: {
    assistData: {
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'authorized'
    ])
  },
  mounted () {
    // this.getLoginCount()
    if (this.authorized) {
      this.$router.push({ name: 'AI_Book' })
    }
  },
  methods: {
    ...mapActions({
      dologin: 'login',
      getUser: 'getUser'
    }),
    async login () {
      const vm = this
      vm.check = true
      try {
        await this.dologin({ email: this.auth.account, password: this.auth.password }).then((res) => {
          console.log(res)
          // if (res.groups) {
          //   const groupsList = {}
          //   for (let i = 0; i < res.groups.length; i++) {
          //     groupsList[res.groups[i].id] = res.groups[i].name
          //   }
          //   vm.$swal({
          //     title: '選擇班級',
          //     input: 'select',
          //     inputOptions: groupsList,
          //     showCancelButton: true,
          //     customClass: {
          //       input: 'my-select'
          //     },
          //     inputValidator: function (value) {
          //       return new Promise(function (resolve, reject) {
          //         api.post(`/me/groups/${value}`)
          //         resolve()
          //         vm.getUser()
          //         vm.$router.push({ name: 'Search' })
          //       })
          //     }
          //   })
          // } else {
          //   this.$router.push({ name: 'AI_Book' })
          // }
        })
        await this.getUser()
        this.$router.push({ name: 'AI_Book' })
      } catch (error) {
        if (error) {
          console.log(error)
        }
        // console.error(error.response.data)
      }
    }
  },
  components: {
    // Video
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    .background {
      display: flex;
      justify-content: center; /* 水平置中 */
      align-items: center; /* 垂直置中 */
      width: 100vw;
      height: 100vh;
      background-image:url('../assets/login/login_bg4.png'),url('../assets/login/login_bg2.png'),url('../assets/login/login_bg3.png');
      background-position:center center, top center,top left;
      background-repeat:no-repeat, repeat-y,no-repeat;
      background-size:1920px auto,1920px 1px,50% 100%;
    }
  }

  //登入框
  .loginBox{
    position:relative;
    max-width:1280px;
    background-color:#FFF;
    background-image:url('../assets/login/login_bg.png');
    background-repeat:repeat-x;
    background-size: auto 100%;
  }
  .loginImg>img{
    display:block;
    width:100%;
    height:auto;
  }
  .loginContent{
    position:absolute;
    top:0px;
    left:0px;
    width:50%;
    height:100%;
  }

  .loginContent>div{
    position:absolute;
    top:50%;
    left:50%;
    width:55%;
    -webkit-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
  }

  .loginContent .title{
    position: relative;
    width: 100%;
    margin-bottom: 2rem;
  }
  .loginContent .title>img{
    display: block;
    width: 100%;
    height: auto
  }

  .loginContent .Input{
    position:relative;
    width: 100%;
    margin:auto;
    margin-bottom: 1rem;
  }

  .loginContent .Input>input{
    position:relative;
    width:100%;
    border:1px solid #aec3ff;
    height: 2.5rem;
    border-radius: 400rem;
    text-align:center;
    padding-left: 2rem;
    padding-right: 2rem;
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    box-sizing: border-box;         /* Opera/IE 8+ */
  }

  .loginContent .Input.mail:after {
    content: "";
    position:absolute;
    display:block;
    top: .6rem;
    left: 1rem;
    width: 1rem;
    height: 1.25rem;
    background-image:url('../assets/login/login_icon01.png');
    background-size:100% auto;

  }

  .loginContent .Input.pw:after {
    content: "";
    position:absolute;
    display:block;
    top: .6rem;
    left: 1rem;
    width: 1rem;
    height: 1.25rem;
    background-image:url('../assets/login/login_icon02.png');
    background-size:100% auto;

  }

  .loginContent .Input>p{
    position:relative;
    font-size: .8rem;
    color: #F00;
    text-align:center;
  }

  .loginContent button{
    display:block;
    border:0px solid #aec3ff;
    width:100%;
    max-width: 200px;
    height:60px;
    margin:auto;
    margin-bottom:4%;
    background-color:#2b358d;
    border-radius:400rem;
    color:#FFF;
    font-size:24px;
    cursor:pointer;

  }
  .loginContent button:hover{
    background-color:#06C;
  }

  .loginContent .fp{
    display:block;
    text-align:center;
    margin:auto;
    width:100%;
    max-width:150px;
    margin-bottom:15%;
  }
  .loginContent .fp:hover{
    color:#09F;
  }

  .loginContent .logo{
    position:relative;
    width:80%;
    max-width:160px;
    margin:auto
  }
  .loginContent .logo>img{
    display:block;
    width:100%;
    height:auto;
  }
  @media screen and (max-width: 1280px) {
    .background {
      background-size:150% auto,1920px 1px,50% 100% !important;
    }
  } /*小於12800*/
  @media screen and (max-width: 700px) {
    .loginImg{
      height: 100vh;
      opacity:0;
    }
    .loginContent{
      position:absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
    }
  } /*小於700*/
</style>
